<template>
  <base-layout>
    <template #header></template>
    <template #default> 
      <el-row class="main-div">
        <!-- 好评列表 -->
        <el-col  :lg="7" :md="7" :xl="7" :xs="22" :sm="22" :offset="1" v-for="(item, i) in wellreceivedList" :key="i">
          <el-card :body-style="{ padding: '0px' }">
            <img :src="'https://api2.seattletaotao.com/'+item.well_image" width="100%" height="468" class="image">
            <div style="padding: 14px;">
              <span>{{item.princess_name}}的好评</span> 
            </div>
          </el-card>
        </el-col>

        <!-- 分页 -->
        <el-col> 
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="9"
            layout="prev, pager, next, jumper"
            :total="totalPage">
          </el-pagination>
        </el-col>

      </el-row>
    </template>
    <template #footer></template>
  </base-layout>
</template>
<script>
let _th;
import BaseLayout from "@/components/BaseLayout"; 
export default {
  data() {
    return {
      msg: "wellreceived",
      url:"https://api2.seattletaotao.com/api/princess/getWellList",
      currentPage:1,
      totalPage:1,
      wellreceivedList:[],
    };
  },
  components: {
    BaseLayout, 
  },
  created () { 
    this.initFun(this.url);
    _th = this;
  },
  
  methods: {
    // 写一个js分叉算法
    
    
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      let u = "https://api2.seattletaotao.com/api/princess/getWellList?page="+val;
      this.initFun();
    },
    initFun(url){  
      fetch(url, {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(result => { 
        return result.json();
      })
      .then(res => { 
        if (res.code == 1) { 
          _th.totalPage = res.data[0];
          _th.wellreceivedList = res.data[2];
          console.log( _th.wellreceivedList);
        }
      })
      .catch(e => {
        console.log("------err--------------------------");
        // _th.$router.go(0)
      });
    }

  },
};
</script>

<style scoped type="text/scss">
/deep/ .el-footer {
  padding: 0 !important;
}
.el-footer {
  padding: 0 !important;
}
 
</style>



// WEBPACK FOOTER //
// src/page/wellreceived.vue